export const parseImgurThumbnail = (url) => {
    // https://i.imgur.com/W2BR8QAm.jpeg
    // https://i.imgur.com/W2BR8QAl.png
    // https://i.imgur.com/rqssuhU.jpeg
    url.replace(/(https?:\/\/i\.imgur\.com\/[a-zA-Z0-9]+)(\.[a-zA-Z]{3,4})/, function (match, p1, p2) {
      if (p1.endsWith("m")) {
        url = p1.substring(0, p1.length - 1) + "" + p2; // 'm' for medium thumbnail, 'l' for large
      }
    });
    return url;
  }